module.exports = __webpack_public_path__ + "img/Priest64_ua.833521fb.webp";